var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-wrapper',{directives:[{name:"bgimage",rawName:"v-bgimage",value:(_vm.$state.page.banner),expression:"$state.page.banner"}],staticClass:"banner"},[_c('h2',[_vm._v(_vm._s(_vm.$state.page.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }